__webpack_require__.p = "/magic_player/";